var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var tabMap = {
    "256": { S: 1, B: 14 },
    "257": { S: 11, B: 24 },
    "278": { S: 10, B: 23 },
    "292": { S: 7, B: 20 },
};
export var ProductTabsMapper = function (productTabs, flag) {
    var _a, _b;
    return ((_a = productTabs === null || productTabs === void 0 ? void 0 : productTabs.data) === null || _a === void 0 ? void 0 : _a[0].tab_name) === "All"
        ? __assign(__assign({}, productTabs), { data: (_b = productTabs === null || productTabs === void 0 ? void 0 : productTabs.data) === null || _b === void 0 ? void 0 : _b.map(function (tab) {
                var _a;
                var key = String(tab.category_code);
                var mapped = (_a = tabMap[key]) === null || _a === void 0 ? void 0 : _a[flag];
                return __assign(__assign({}, tab), { tab_id: (tab === null || tab === void 0 ? void 0 : tab.tab_name) === "All" ? mapped : tab.tab_id });
            }) }) : productTabs;
};
